import React from 'react';
import {
  StandardInputBaseProps,
  inputContainerStyles,
  labelStyles,
  requiredIndicatorStyles,
  getInputClassName,
} from './StandardInputStyles';
import Loading from '@/common/components/Loading';

interface Props extends Omit<StandardInputBaseProps, 'label'> {
  description?: string;
  onChange: React.ChangeEventHandler<HTMLInputElement> | undefined;
  disabled?: boolean;
  onBlur?: React.FocusEventHandler<HTMLInputElement> | undefined;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement> | undefined;
  onClick?: React.MouseEventHandler<HTMLInputElement> | undefined;
  autoFocus?: boolean;
  label?: string;
}

export default function StandardInputText({
  id,
  label,
  isRequired,
  placeholderText,
  value,
  onChange,
  isLoading = false,
  disabled = false,
  description,
  onBlur,
  onKeyDown,
  onClick,
  autoFocus,
}: Props) {
  return (
    <div className={inputContainerStyles}>
      {label && (
        <label htmlFor={id} className={labelStyles}>
          {label}
          {isRequired && <span className={requiredIndicatorStyles}>*</span>}
        </label>
      )}
      {description && <p className='text-sm text-text_gray_900 mt-1'>{description}</p>}
      <div className='w-full flex flex-col relative'>
        <input
          type='text'
          id={id}
          placeholder={placeholderText ?? ''}
          className={getInputClassName('text')}
          value={value}
          onChange={onChange}
          disabled={disabled}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          onClick={onClick}
          autoFocus={autoFocus}
        />
        {isLoading && (
          <div className='absolute top-0 left-0 z-10 w-full h-full flex items-center justify-center bg-surface_gray_50 opacity-70'>
            <Loading
              text=''
              loadingClass={'max-h-[150px] max-w-[150px] w-8 h-8 z-20'}
              textClass='z-20'
            />
          </div>
        )}
      </div>
    </div>
  );
}
